import { LazyComponent } from "../hoc";

type PropertyListPageLayoutProps = {
  cities: any;
  children: React.ReactNode;
};

export const PropertyListPageLayout: React.FC<PropertyListPageLayoutProps> = ({
  cities,
  children,
}) => {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="sticky top-0 z-40 bg-white">
        <LazyComponent
          importFunc={() => import("app-v2").then((mod) => mod.Header)}
          cities={cities}
          showSearch
        />
      </div>
      {children}

      <HiddenSeoLinks />
    </div>
  );
};

const HiddenSeoLinks = () => (
  <div className="hidden">
    <a href="/">home</a>
    <a href="/services">services</a>
    <a href="/auction-properties">properties</a>
    <a href="/contactus">contactus</a>
    <a href="/signup">signup</a>
    <a href="/aboutus">aboutus</a>
    <a href="/faq">faq</a>
    <a href="/privacypolicy">privacypolicy</a>
    <a href="/termsandconditions">termsandconditions</a>

    <a href="/auction-properties?start_from=asset-type&asset_type=residential">
      properties
    </a>
    <a href="/auction-properties?start_from=asset-type&asset_type=commercial">
      properties
    </a>
    <a href="/auction-properties?start_from=asset-type&asset_type=industrial">
      properties
    </a>
  </div>
);
